import React, { useState } from 'react';
import { Button, Input, Typography, message } from 'antd';

import { apiPHP } from '../../../../services/api';
import { apiErrorMessage, fieldLabel, type GeneratorProps } from './types';

// Gerador de caça-palavras (POST /generate_wordsearch) do "+ Novo jogo" (quem anuncia o sucesso é o assistente).

interface GenerateWordsearchResponse {
  id_jogo: number;
  palavras: string[];
}

export const WordsearchGenerator: React.FC<GeneratorProps> = ({ resolveTitle, onCreated }) => {
  const [palavras, setPalavras] = useState('');
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    const titulo = await resolveTitle();
    if (titulo === null) return;
    const list = palavras
      .split(/[\n,;]+/)
      .map((s) => s.trim())
      .filter(Boolean);
    if (list.length === 0) {
      message.error('Digite ao menos uma palavra.');
      return;
    }
    setLoading(true);
    try {
      const { data } = await apiPHP.post<GenerateWordsearchResponse>('/generate_wordsearch', {
        titulo,
        palavras: list,
      });
      onCreated(data.id_jogo);
    } catch (e: unknown) {
      message.error(apiErrorMessage(e, 'Falha ao gerar o caça-palavras.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Typography.Paragraph type="secondary">
        Digite só a lista de palavras — o tabuleiro é montado automaticamente.
      </Typography.Paragraph>
      <label style={fieldLabel} htmlFor="wordsearch-words">
        Palavras (uma por linha, ou separadas por vírgula)
      </label>
      <Input.TextArea
        id="wordsearch-words"
        value={palavras}
        onChange={(e) => setPalavras(e.target.value)}
        rows={5}
        placeholder={'SOL\nLUA\nMAR\nESTRELA'}
      />
      <Button type="primary" loading={loading} onClick={generate} style={{ marginTop: 12 }}>
        Gerar caça-palavras
      </Button>
    </div>
  );
};

export default WordsearchGenerator;
